export interface alchemyState {
  bases: Array<string>;
  mutagens: Array<string>;
  potions: Array<string>;
  reagents: Array<string>;
}

export default {
  namespaced: true,
  state: (): alchemyState => ({
    bases: [],
    mutagens: [],
    potions: [],
    reagents: [],
  }),
  getters: {
    bases: (state: alchemyState) => {
      return state.bases;
    },
    mutagens: (state: alchemyState) => {
      return state.mutagens;
    },
    potions: (state: alchemyState) => {
      return state.potions;
    },
    reagents: (state: alchemyState) => {
      return state.reagents;
    },
    alchemy: (state: alchemyState) => {
      return {
        bases: state.bases,
        mutagens: state.mutagens,
        potions: state.potions,
        reagents: state.reagents,
      };
    },
  },
  mutations: {
    setBases: (state: alchemyState, newData: Array<string>) => {
      state.bases = newData;
    },
    setMutagens: (state: alchemyState, newData: Array<string>) => {
      state.mutagens = newData;
    },
    setPotions: (state: alchemyState, newData: Array<string>) => {
      state.potions = newData;
    },
    setReagents: (state: alchemyState, newData: Array<string>) => {
      state.reagents = newData;
    },
  },
};
